import React from "react";
import { LOGO_URL } from "../../content";

/**
 * MET logo with color rules:
 *  - variant="white"  → for dark/gradient backgrounds
 *  - variant="brand"  → for white/light backgrounds (rendered in #005870)
 *
 * The original asset is a white PNG on transparent bg. For the brand variant
 * we use CSS mask-image so the alpha shape is preserved while the color is
 * applied via background-color.
 */
export default function MetLogo({ variant = "white", className = "h-12 w-12", testid = "met-logo" }) {
  if (variant === "white") {
    return (
      <img
        src={LOGO_URL}
        alt="MET France"
        data-testid={testid}
        className={`${className} object-contain`}
      />
    );
  }

  return (
    <span
      role="img"
      aria-label="MET France"
      data-testid={testid}
      className={`${className} inline-block`}
      style={{
        WebkitMaskImage: `url(${LOGO_URL})`,
        maskImage: `url(${LOGO_URL})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        backgroundColor: "#005870",
      }}
    />
  );
}
